class SiteWidePopup extends HTMLElement {
    constructor() {
        super();

        this.timeout = this.dataset.delay;
        this.timeoutLength = parseInt(this.timeout) * 1000;
        this.delayedTimeout = this.timeoutLength + 500;

        if (document.cookie.includes("popup_dismissed=true")) {
            this.setAttribute("hidden", "hidden");
        } else {
            
            let ageVerified = sessionStorage.getItem('ageVerified');
            if (ageVerified === 'true') {
                this.toggleSitewidePopup();
            }
            else {
                document.addEventListener('age-gate:deactivated', this.toggleSitewidePopup.bind(this));
            }

        }
    }

    toggleSitewidePopup() {
        this.displayPopup()

        setTimeout(() => {
            document.body.addEventListener("click", this.closePopup.bind(this));
            document.addEventListener('keydown', (event) => {
                if (event.key === 'Escape') {
                    this.closePopup.bind(this)
                }
            });
        }, this.delayedTimeout);
    }

    displayPopup() {
        setTimeout(() => {
            this.classList.add('start-activate');
		}, this.timeoutLength);
        setTimeout(() => {
			this.classList.add("full-activate");
            const overlay = document.createElement('div');
            overlay.classList.add('sitewide-popup_fullscreen-overlay');
            document.body.appendChild(overlay);
		}, this.delayedTimeout);
    }

    closePopup() {
		document.cookie = "popup_dismissed=true;path=/;secure;samesite=strict";
        this.classList.remove("full-activate");
        this.classList.remove('start-activate');
        document.querySelector('.sitewide-popup_fullscreen-overlay').remove();
		setTimeout(() => {
			this.setAttribute("hidden", "hidden");
		}, 2000);
	}

}

customElements.define('site-wide-popup', SiteWidePopup);
